'use strict';

const NavConfig = function ($stateProvider) {

  $stateProvider.state('navLeft', {
    url: '',
    abstract: true,
    parent: 'layout',
    views: {
      navLeft: {
        templateUrl: 'dash/nav/navLeft/navLeft.tpl.html'
      }
    }
  });
}

NavConfig.$inject = ['$stateProvider'];
module.exports = NavConfig;


// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/NavConfig.js